import _ from "lodash";
import store from "services/redux/store";
import { setData } from "services/redux/data/actions";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchEmployee from 'utils/fetch/FetchEmployee'
import { dataConstants } from 'services/redux/data/constants'

export default class FetchCachedMyEmployee
{
	static logName = 'FetchCachedMyEmployee';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'my_employee',
				tables: [ 'my_employee' ],
				onExpire: this.reload,
				updated_at_max_age: ( 30 ) // updated_at needs to be refresh at most each 2 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( {callbackSuccess = null, callbackError = null, callbackStart = null } = {}) => {
		if ( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
			callbackSuccess();
		}
	}
	
	static reload = ( {callbackSuccess = null, callbackError = null, callbackStart = null} = {} ) =>{
		this.construct().then( () => {
			const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
			
			if( _.get( _employee, 'guid', null ) !== null ){
				FetchEmployee.fetch( _.get( _employee, 'guid' ), {
					callbackSuccess: ( { employee } ) => {
						this.process( employee );
						if( _.isFunction( callbackSuccess ) ){
							callbackSuccess( { employee: this.values } )
						}
					}
				});
			}
		})
	}
	
	static process = ( employee ) => {
		this.values = employee;
		store.dispatch( setData( dataConstants.EMPLOYEE, employee ) );
	}
}
